import { gql } from '@apollo/client';

export const PROGRAMME = gql`
  fragment programme on Programme {
    id
    name
    isArchived
    theoryOfChange
    fromDate
    toDate
    districts
    institutions
    beneficiaries
    sitesCount
    owner {
      id
      firstName
      lastName
    }
  }
`;
